import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapFields } from "@joandvgv/vuex-map-fields";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import { LOAD_BOARDS } from "@Broker/@Modules/clients/board/store/board-actions";
import { BOARDS } from "@Broker/@Modules/clients/board/store/board-getters";
import PageHeader from "@Shared/components/general/page-header.vue";
import { LOAD_AUTOMATION_DATA, LOAD_APPLICATION_AUTOMATIONS } from "../store/automation-actions";
import { AUTOMATION_BY_PATH } from "../store/automation-getters";
import AutomationsLoader from "./automations-loader.vue";
import AutomationLevelTabs from "./automation-level-tabs.vue";
import { SET_LOADING } from "../store/automation-mutations";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AutomationContainer",
  components: {
    PageHeader,
    AutomationsLoader,
    AutomationLevelTabs
  },
  props: {
    highlight: {
      type: Object,
      default: () => null
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("AutomationStore", {
    loading: "loading"
  })), mapFields("AccountStore", ["accountPreferences.defaultListId", "accountPreferences.defaultEmailName", "accountPreferences.defaultEmailId"])), mapGetters("AutomationStore", [AUTOMATION_BY_PATH])), mapGetters("BoardStore", [BOARDS])), {}, {
    pageIsDocumentAutomations() {
      return this.$route.name === "document-automations";
    },
    preloadAutomationData() {
      return !this.pageIsDocumentAutomations;
    }
  }),
  mounted() {
    if (!this.preloadAutomationData) {
      this.SET_LOADING(false);
      return;
    }
    if (!this.BOARDS.length) this.LOAD_BOARDS();
    this.LOAD_AUTOMATION_DATA().then(() => {
      if (this.highlight && this.highlight.path) {
        const automation = this.AUTOMATION_BY_PATH(this.highlight);
        this.$nextTick(() => {
          $(`.automation-${automation.id}`).highlight();
        });
      }
    });
    const {
      selectedTemplate
    } = this.$route.params;
    if (!selectedTemplate) {
      this.LOAD_APPLICATION_AUTOMATIONS();
    }
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("AutomationStore", [LOAD_AUTOMATION_DATA, LOAD_APPLICATION_AUTOMATIONS])), mapActions("BoardStore", [LOAD_BOARDS])), mapMutations("AutomationStore", [SET_LOADING]))
});